import Vue              from "vue";
import ToolTipPopOver   from "@/components/Elements/ToolTipPopover.vue"

// facet values that need tooltip
const mastTypes = ["FS", "F", "V", "FSV", "FV", "M", "QFV"];
const engineTypes = ["DHM", "DPR", "HCB", "STM"];

export default Vue.extend({
    name: "TmsFacetExtras",
    components: {
        ToolTipPopOver
    },
    created() {
        this.setShowToyotaEnginePopup();
        this.setShowToyotaMastPopup();
    },
    computed: {
        showCommonAllText() {
            if(this.facetKey === "Common_Parts") {
                return "SHOW ALL"
            } else {
                return "SHOW COMMON"
            }
        }
    },
    props: {
        facet: {
            type: Array,
            default: () => []
        },
        facetKey: {
            type: String,
            default: () => ""
        },
        selectedFacets: {
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        showToyotaEnginePopup: false,
        showToyotaMastPopup: false,
        toyotaEnginePopupTitle: "TOYOTA ENGINE",
        toyotaEnginePopupText: `<b>DHM</b> - DUST PROOF HIGH CAPACITY BATTERY MOTOR
                                <br /><b>DPR</b> - DUST PROOF MOTOR
                                <br /><b>HCB</b> - HIGH CAPACITY BATTERY MOTOR
                                <br /><b>STM</b> - STANDARD MOTOR`,
        toyotaMastPopupTitle: "TOYOTA MAST",
        toyotaMastPopupText: `<b>FS</b> - 3 STAGE FULL FREE LIFT
                                <br /><b>F</b> - 2 STAGE FULL FREE LIFT
                                <br /><b>V</b> - 2 STAGE WIDE VIEW
                                <br /><b>FSV</b> - 3 STAGE WIDE VIEW FULL FREE LIFT
                                <br /><b>FV</b> - 2 STAGE WIDE VIEW FULL FREE LIFT
                                <br /><b>M</b> - 2 STAGE STANDARD
                                <br /><b>QFV</b> - 4 STAGE WIDE VIEW FULL FREE LIFT`

    }),
    methods: {
        setShowToyotaEnginePopup() {
            // if already true, bail, no need to continue running code
            if (this.showToyotaEnginePopup) {
                return;
            }
            
            // match facet against array, return true on match
            var self = this;
            if (this.facetKey === "Engine") {
                this.facet.forEach(function (engineType: any) {
                    if (engineTypes.includes(engineType.Key)) {
                        self.showToyotaEnginePopup = true;
                    }
                });
            }
        },
        setShowToyotaMastPopup() {
            // if already true, bail, no need to continue running code
            if (this.showToyotaMastPopup) {
                return;
            }

            // match facet against array, return true on match
            var self = this;
            if (this.facetKey === "Mast") {
                this.facet.forEach(function (mastType: any) {
                    if (mastTypes.includes(mastType.Key)) {
                        self.showToyotaMastPopup = true;
                    }
                });
            }
        },
        addFacet(key: String, value: string) {
            this.$emit("add-facet", key, value);
        }
    }
});
